/** Reducers named with d_** is pure data. All others are UI state */
import { combineReducers } from 'redux';
import { form } from 'components/forms/reducer';
import { connectRouter } from 'connected-react-router';
import { history } from 'app.history';
import { websiteReducer as d_website } from 'common/reducers/website';
import { termsAndConditionsReducer as d_termsAndConditions } from 'common/reducers/termsAndConditions';
import { currentUserReducer as currentUser } from 'common/reducers/currentUser';

import { channelsReducer as d_channels } from 'common/reducers/channels';
import { savedVideosReducer as d_savedVideos } from 'pages/saved-videos.page/reducer';
import { settingsReducer as d_settings } from 'common/reducers/settings';
import { collectionReducer as collection } from 'common/reducers/collection';
import { reducer as dialog } from 'components/redux-dialog/reducer';
import { uploadPageReducer as upload } from 'pages/upload.page/reducer';
import { homePageReducer as home } from 'pages/home.page/reducer';
import { navigationReducer as navigation } from 'common/reducers/navigation';
import { videoBoxReducer as videoBox } from 'components/video-box/reducer';
import { relatedVideosReducer as relatedVideos } from 'components/video-box/related-videos/reducer';
import { videoCommentsReducer as videoComments } from 'components/video-box/video-comments/reducer';
import { videoCarouselReducer as carousels } from 'pages/home.page/video-carousel/reducer';
import { errorHandleReducer as errorHandle } from 'components/error-handle/reducer';
import { integrationReducer as integration } from 'common/reducers/integration';
import { AdminReducer as admin } from 'pages/administration.page/reducer';
import { myVideosPageReducer as myVideos } from 'pages/my-videos.page/reducer';
import { videoAttachmentsReducer as videoAttachments } from 'components/video-box/video-attachments/reducer';
import { contentMaskReducer as contentMask } from 'components/header/content-mask/reducer';
import { customReducer as custom } from 'common/reducers/custom';
import { reduxNotificationReducer as notification } from 'components/redux-notification/reducer';
import { reducer as animatedThumbnails } from 'components/video-generating/reducer';
import { usersReducer as users } from './users';
import { searchReducer as search } from 'common/reducers/search';

export const rootReducer = combineReducers({
  d_channels,
  d_settings,
  d_savedVideos,
  d_website,
  errorHandle,
  navigation,
  home,
  collection,
  upload,
  videoBox,
  relatedVideos,
  videoComments,
  integration,
  admin,
  form,
  dialog,
  carousels,
  myVideos,
  videoAttachments,
  contentMask,
  custom,
  notification,
  users,
  router: connectRouter(history),
  animatedThumbnails,
  d_termsAndConditions,
  currentUser,
  search,
});
